import React, {useState, useEffect}  from 'react';
import LaunchFooter from './LaunchFooter';
import LaunchHeader from './LaunchHeader';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import './ScenarioLaunch.css';
import { customRouter } from '../../../CustomRouter';
import { Windows } from '../../../pages/MainPage';

const ScenarioLaunch = (obj: any) => {
	const onClick = () => {
		if(obj.link)
			//window.location.href = obj.link;
			obj.updateWindow(obj.link);
	};
	const [displayed, setDisplayed] = useState(false);
	const [bgIndex, setBgIndex] = useState(0);
	const [background, setBackground] = useState(obj.backgrounds && obj.backgrounds[bgIndex] ? obj.backgrounds[bgIndex] : obj.background);

	useEffect(() => {
		var interval : any;
		if(obj.backgrounds){
			interval = setInterval(function(){ 
				let localIndex = obj.backgrounds.indexOf(background);
				if(localIndex == obj.backgrounds.length - 1){
					localIndex = 0;
				}
				else{
					localIndex++;
				}

				setBackground(obj.backgrounds[localIndex]);

			}, 3000);
		}
		return () => {
			clearInterval(interval);
		};
	}, [background]);

	return (
		<div className="ui-inner-container launch-scenario-container modal-disable-select" style={{ visibility: displayed ? 'visible' : 'hidden' }}>
			<div className="background-image" style={{ backgroundImage: 'url(\'' + background + '\')' }} title={`Victim before and after the accident ${(obj.backgrounds.indexOf(background) + 1)}/3`}></div>
			{!displayed && <LazyLoadImage
				src={background}
				afterLoad={() => {setDisplayed(true);}}
			/>
			}
			<LaunchHeader
				text={obj.text}
				onClose={obj.onClose} /><LaunchFooter onClick={onClick} description={obj.description} />
			<audio src={obj.audio} autoPlay playsInline />
		</div>
	);
};

export default ScenarioLaunch;